module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.country === 'AU' ? 'https://forms.gle/32AmjZTQXWQHs5su7' : 'https://dancestudio-pro.com/online/campbelldancers',
      "target": "_blank"
    }
  }, [_vm._v("Enroll")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f768dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnrollButton.vue
// module id = 104
// module chunks = 1